import { useEffect, useState } from "react";
import { lessonBlockDefaultPaymentAmount } from "./lessonBlockSaleModel.js";
import type { LessonBlockProduct, ProviderService } from "./staff.js";

/**
 * Keep the editable payment field aligned with the currently selected block
 * product and provider-service catalogue. Both the full staff sale form and
 * the tutor shortcut use this hook so defaulting rules cannot drift apart.
 */
export function useLessonBlockPaymentAmount(
  product: LessonBlockProduct | undefined,
  services: readonly ProviderService[],
): readonly [string, (value: string) => void] {
  const defaultAmount = lessonBlockDefaultPaymentAmount(product, services);
  const [amount, setAmount] = useState(defaultAmount);

  useEffect(() => {
    setAmount(defaultAmount);
  }, [defaultAmount, product?.id]);

  return [amount, setAmount] as const;
}
